import { reactive } from "vue";
import { i18n } from "@/i18n";
const t = (key) => String(i18n.global.t(key));
const defaultsByVariante = {
    primary: {
        icono: "bi-question-circle",
        btnClass: "btn-primary",
        iconClass: "confirm-icon-primary",
    },
    success: {
        icono: "bi-check-circle",
        btnClass: "btn-success",
        iconClass: "confirm-icon-success",
    },
    danger: {
        icono: "bi-exclamation-triangle",
        btnClass: "btn-danger",
        iconClass: "confirm-icon-danger",
    },
    warning: {
        icono: "bi-exclamation-circle",
        btnClass: "btn-warning",
        iconClass: "confirm-icon-warning",
    },
    info: {
        icono: "bi-info-circle",
        btnClass: "btn-primary",
        iconClass: "confirm-icon-info",
    },
};
const state = reactive({
    visible: false,
    modo: "confirm",
    titulo: "",
    mensaje: "",
    detalle: "",
    textoConfirmar: "Confirm",
    textoCancelar: "Cancel",
    variante: "primary",
    modulo: "general",
    icono: "",
    promptLabel: "",
    promptPlaceholder: "",
    promptRequired: false,
    promptValue: "",
    resolve: null,
});
/** Solo para ConfirmacionAppModal (v-model del prompt). */
export const confirmacionState = state;
export const getConfirmacionEstilos = (variante) => defaultsByVariante[variante] ?? defaultsByVariante.primary;
const abrir = (opts, modo) => {
    const estilos = getConfirmacionEstilos(opts.variante ?? "primary");
    state.modo = modo;
    state.titulo = opts.titulo;
    state.mensaje = opts.mensaje;
    state.detalle = opts.detalle ?? "";
    state.textoConfirmar =
        opts.textoConfirmar ??
            (modo === "alert" ? t("common.understood") : t("common.confirm"));
    state.textoCancelar = opts.textoCancelar ?? t("common.cancel");
    state.variante = opts.variante ?? "primary";
    state.modulo = opts.modulo ?? "general";
    state.icono = opts.icono ?? estilos.icono;
    state.promptLabel = opts.promptLabel ?? "";
    state.promptPlaceholder = opts.promptPlaceholder ?? "";
    state.promptRequired = opts.promptRequired ?? false;
    state.promptValue = "";
    state.visible = true;
};
export const confirmar = (opts) => new Promise((resolve) => {
    state.resolve = (v) => resolve(v === true);
    abrir(opts, "confirm");
});
export const alerta = (opts) => new Promise((resolve) => {
    state.resolve = () => resolve();
    abrir({
        ...opts,
        variante: opts.variante ?? "danger",
        icono: opts.icono ?? "bi-x-circle",
    }, "alert");
});
export const promptComentario = (opts) => new Promise((resolve) => {
    state.resolve = (v) => {
        if (v === false || v === null)
            resolve(null);
        else
            resolve(typeof v === "string" ? v : "");
    };
    abrir({
        ...opts,
        textoConfirmar: opts.textoConfirmar ?? t("common.confirm"),
    }, "prompt");
});
export const cerrarConfirmacion = (aceptado) => {
    state.visible = false;
    const fn = state.resolve;
    state.resolve = null;
    fn?.(aceptado);
};
export const confirmarPrompt = () => {
    if (state.modo === "prompt" && state.promptRequired && !state.promptValue.trim()) {
        return;
    }
    const valor = state.modo === "prompt" ? state.promptValue.trim() : true;
    cerrarConfirmacion(state.modo === "prompt" ? valor : true);
};
